export const EDUCATION_PAY_RATE = 15;
export const BASE_EDUACTION_RECOMMENDATION = `Make the base pay education "High School" or increase the pay to $${EDUCATION_PAY_RATE}/hr`;
